const faqs = [
  {
    q: '麻花影院的4K画质需要什么网络条件？',
    a: '麻花影院采用先进的智能码率适配技术，4K超清画质建议20Mbps以上带宽即可流畅观看。在网络条件不足时，系统会自动调整为蓝光1080P或高清720P，确保观影不卡顿、不缓冲。无论您使用光纤宽带还是移动网络，都能获得当前条件下的最佳画质体验。',
  },
  {
    q: '平台上的电影资源多久更新一次？',
    a: '麻花影院内容团队每日更新，新片从院线下映后最快30天内即可在平台看到4K超清版本。经典影片库也在持续扩充，每周新增50+部经过精心修复的蓝光画质佳作。关注我们的最新动态板块，第一时间获取更新资讯。',
  },
  {
    q: '支持哪些设备观看？有APP吗？',
    a: '麻花影院全面支持电脑浏览器、平板和手机端观看，网页端即开即看无需安装。同时我们提供专属APP，支持iOS和安卓系统，在APP中可享受离线缓存、观影记录同步等专属功能。所有设备均支持4K超清画质播放，具体取决于您设备的屏幕分辨率。',
  },
  {
    q: '观影完全免费吗？是否有广告？',
    a: '麻花影院致力于为影迷提供优质的超清观影体验。基础观影服务免费开放，支持4K蓝光画质。我们通过精选内容推荐和专题策划来提升您的观影品质，确保观影过程清爽流畅，不被无关广告打扰。部分独家内容和最新大片可能设有观影次数限制，详情见平台公告。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 bg-secondary-100/80 px-4 py-2 rounded-full mb-5">
              <i className="ri-question-answer-line text-secondary-600 text-sm"></i>
              <span className="text-secondary-700 text-xs font-medium">快速解答</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              关于麻花影院超清观影体验的常见疑问
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq) => (
              <details key={faq.q} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden" open>
                <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                  <h3 className="font-heading text-foreground-900 font-semibold text-sm pr-4">{faq.q}</h3>
                  <div className="w-7 h-7 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 transition-colors">
                    <i className="ri-subtract-line text-primary-600 text-sm"></i>
                  </div>
                </summary>
                <div className="px-6 pb-5">
                  <p className="text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}